import formatDate from "../helpers/date";
import decodeHtml from "../helpers/decode";

function Event(hit, helpers) {
	const { html, components, sendEvent } = helpers;

	if (hit._highlightResult && hit._highlightResult.post_title && hit._highlightResult.post_title.value) {
		// decode the highlighted title
		hit._highlightResult.post_title.value = decodeHtml(hit._highlightResult.post_title.value);
	}

	const month = formatDate(hit.post_date, 'month');
	let day = formatDate(hit.post_date, 'day');
	const year = formatDate(hit.post_date, 'year');
	const startTime = formatDate(hit.post_date, 'time');
	const endTime = formatDate(hit.end_date, 'timezone');
	const time = Array.isArray( hit.start_end_time ) ? hit.start_end_time : [ hit.start_end_time ];

	console.log( time );

	const end_day = formatDate(hit.end_date, 'day');
	const end_month = formatDate(hit.end_date, 'month');
	const end_year = formatDate(hit.end_date, 'year');
	let eventDate;
	if ( end_month !== month || end_year !== year ) {
		const abbreviatedMonth = formatDate(hit.post_date, 'M' );
		const abbreviatedEndMonth = formatDate(hit.end_date, 'M' );
		let start_date = abbreviatedMonth + ' ' + day;
		let end_date = abbreviatedEndMonth + ' ' + day;
		let monthClass = 'month multi-month';
		if ( end_year !== year ) {
			monthClass = 'month multi-month multi-year';
			start_date = start_date + ', ' + year;
			end_date = end_date + ', ' + end_year;
		}
		eventDate = html `
			<span class="${monthClass}">${start_date} - </span>
			<span class="${monthClass}">${end_date}</span>
			<p class="year">${year}</p>
		`;
	} else {
		let dayClass = 'day';
		if ( end_day !== day ) {
			dayClass = 'day multi-day';
			day = day + '-' + end_day;
		}
		eventDate = html `
			<span class="month">${month}</span>
			<span class="${dayClass}">${day}</span>
			<p class="year">${year}</p>
		`;
	}

	// determine if post_date is in the past
	const now = new Date();
	const postDate = new Date(hit.post_date * 1000);
	const isPast = postDate < now;

	// determine if end_date is in the past
	let endDate = '';
	let isEndDatePast = isPast;
	if ( hit.end_date ) {
		endDate = new Date(hit.end_date * 1000);
		isEndDatePast = endDate < now;
	}

	const status = isPast ? ( isEndDatePast ? 'Past Event' : 'Live Event' ) : 'Upcoming';

	const themeColor = isPast ? 'theme-medium-gray' : 'theme-medium-blue';

	// const permalink = hit.permalink;
	const permalink = hit.permalink.replace('preview.brookings.edu', 'www.brookings.edu');

	return html `
	<article class="article event group article-feed event-past">
		<a href="${permalink}" class="overlay-link">
		<span class="sr-only">${hit.post_title}</span>
		</a>
		<div class="img-wrapper">
			<figure>
				<div class="calendar-square ${themeColor}">
					<div class="overlay group-hover:opacity-100"></div>
					<div class="calendar-wrapper">
						<div class="calendar-label">
							<span class="label-small">
							${status}
							</span>
						</div>
					<div class="event-date">
						${eventDate}
					</div>
				</div>
			</div>
		</figure>
		</div>
	
		<div class="article-insert">
			<span class="article-type">${hit.primary_topic}</span>
			<span class="article-insert-details">
				<span class="article-title group-hover:text-link-underline-hovered">
				${components.Highlight({ hit, attribute: 'post_title' })}
				</span>
				<span class="meta">
					<p class="location">
						${hit.location}
					</p>
					<p class="time">
						${time.map((date) => html`${date}<br/>`)}
					</p>
				</span>
				<p class="hit-text">${components.Snippet({ hit, attribute: 'content' })}</p>
			</span>
		</div>
	</article>
	`;
}

export default Event;
